import { render, staticRenderFns } from "./EditQuestionDialog.vue?vue&type=template&id=db25c652&scoped=true"
import script from "./EditQuestionDialog.vue?vue&type=script&lang=js"
export * from "./EditQuestionDialog.vue?vue&type=script&lang=js"
import style0 from "./EditQuestionDialog.vue?vue&type=style&index=0&id=db25c652&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db25c652",
  null
  
)

export default component.exports